"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _url = require("ui-addon-upgrades/_core/common/navigation/url");

var _getUpgradeLink = require("../common/adapters/getUpgradeLink");

var _submitPql = require("../pql/submitPql");

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _getSalesPhoneNumber2 = _interopRequireDefault(require("ui-addon-upgrades/_core/common/adapters/getSalesPhoneNumber"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H2"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _links = require("self-service-api/core/utilities/links");

var _UpgradeProducts = require("self-service-api/constants/UpgradeProducts");

var UnassignableModal = function UnassignableModal(_ref) {
  var upgradeData = _ref.upgradeData,
      onClose = _ref.onClose;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isCallSectionVisible = _useState2[0],
      setIsCallSectionVisible = _useState2[1];

  (0, _react.useEffect)(function () {
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'viewed unassignable modal'
    }, upgradeData));
  }, [upgradeData]);

  var handleClickChat = function handleClickChat() {
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable chat button'
    }, upgradeData));
    var upgradeLink = upgradeData.upgradeProduct === _UpgradeProducts.GENERAL ? (0, _links.salesPricing)(upgradeData.source) : (0, _getUpgradeLink.getUpgradeLink)(upgradeData);
    (0, _url.openNewTab)(upgradeLink + "&show-tts-chat=true");
  };

  var handleClickCall = function handleClickCall() {
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone button'
    }, upgradeData));
    (0, _submitPql.submitPql)(upgradeData);
    setIsCallSectionVisible(true);
  };

  var handleChatBackButtonClick = function handleChatBackButtonClick() {
    tracker.track('communicationMethodsInteraction', Object.assign({
      action: 'clicked unassignable phone back button'
    }, upgradeData));
    setIsCallSectionVisible(false);
  };

  var _getSalesPhoneNumber = (0, _getSalesPhoneNumber2.default)(_I18n.default.lang, _I18n.default.locale),
      phoneNumber = _getSalesPhoneNumber.phoneNumber,
      countryCode = _getSalesPhoneNumber.countryCode;

  return _react.default.createElement(_UIModal.default, {
    width: 550,
    use: "conversational"
  }, isCallSectionVisible ? _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: onClose
  }), _react.default.createElement(_H.default, {
    className: "m-bottom-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "upgrades.communicationMethods.callSales"
  }))), _react.default.createElement(_UIDialogBody.default, {
    className: "p-bottom-10"
  }, _react.default.createElement("div", {
    className: "communication-call-submit-success"
  }, _react.default.createElement(_H2.default, {
    className: "m-bottom-0"
  }, phoneNumber), _react.default.createElement(_Small.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "SharedI18nStrings.countryCodes." + countryCode
  }))), _react.default.createElement(_UIButton.default, {
    className: "m-top-8",
    onClick: handleChatBackButtonClick,
    use: "link"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "upgrades.communicationMethods.backButton"
  })))) : _react.default.createElement(_react.Fragment, null, _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement(_UIDialogCloseButton.default, {
    onClick: onClose
  }), _react.default.createElement("h2", {
    className: "m-bottom-8"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "upgrades.communicationMethods.title"
  }))), _react.default.createElement(_UIDialogBody.default, {
    className: "p-bottom-10"
  }, _react.default.createElement(_UIFlex.default, {
    justify: "center"
  }, _react.default.createElement(_UIFlex.default, {
    justify: "center",
    style: {
      width: '100%'
    }
  }, _react.default.createElement(_UISelectableButton.default, {
    selected: false,
    size: "large",
    textLabel: _react.default.createElement(_FormattedMessage.default, {
      message: "upgrades.communicationMethods.callUs"
    }),
    onClick: handleClickCall
  }, _react.default.createElement(_UIIllustration.default, {
    name: "calling-small",
    height: 75
  })), _react.default.createElement(_UISelectableButton.default, {
    selected: false,
    size: "large",
    textLabel: _react.default.createElement(_FormattedMessage.default, {
      message: "upgrades.communicationMethods.chatWithUs"
    }),
    onClick: handleClickChat
  }, _react.default.createElement(_UIIllustration.default, {
    name: "contacts-chat",
    height: 75
  })))))));
};

var _default = UnassignableModal;
exports.default = _default;
module.exports = exports.default;